import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/LinkedInPostsAll.css';

function LinkedInPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://n8n.iniai.cloud/webhook/linkedin-posts', {
      headers: {
        'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log("API Response:", response.data);
      setPosts(response.data);
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching posts:', error);
      setLoading(false);
    });
  }, []);

  if (loading) return <div>Loading posts...</div>;

  return (
    <div className="linkedin-posts">
      {posts.map(post => (
        <div key={post.id} className="post-card">
          <div className="post-meta">
            <span className="post-author">{post['Name (from Writer ID)']?.[0]}</span>
            <span className="post-date">{new Date(post['Generated Date']).toLocaleDateString()}</span>
          </div>
          <p className="post-content">{post['Generated Content']}</p>
        </div>
      ))}
    </div>
  );
}

export default LinkedInPosts;